import { render, staticRenderFns } from "./BookingHotel.vue?vue&type=template&id=0fb87ae8&scoped=true"
import script from "./BookingHotel.vue?vue&type=script&lang=js"
export * from "./BookingHotel.vue?vue&type=script&lang=js"
import style0 from "./BookingHotel.vue?vue&type=style&index=0&id=0fb87ae8&prod&lang=css"
import style1 from "./BookingHotel.vue?vue&type=style&index=1&id=0fb87ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb87ae8",
  null
  
)

export default component.exports